module.exports = __webpack_public_path__ + "media/images/responsive/flow/flow4-waso-de0d5efc7671cb5915b184c12aa475b3.jpg";